import React from 'react';
import {
  formatToLocaleEventDate,
  getReadableTimeDifferenceInLocale,
} from '../../../../../helpers/dateHelpers';
import { IDueActivityWarning } from './interfaces';
import { useTranslation } from 'react-i18next';
import { getActivityDateType, getPlannedActivityDueDate } from '../../helpers';
import { Alert } from '../../../../../components/Alert';

export const DueActivityWarning: React.FC<IDueActivityWarning> = ({
  plannedActivity,
}): JSX.Element => {
  const { t } = useTranslation();
  const dateType = getActivityDateType(plannedActivity);

  const dateStr = (() => {
    if (dateType === 'exact') {
      return formatToLocaleEventDate(
        getPlannedActivityDueDate(plannedActivity)
      );
    }

    if (dateType === 'range') {
      return (
        formatToLocaleEventDate(plannedActivity.performAt, false) +
        ' ' +
        t('plannedActivities:alerts.overdue.between', {
          start: plannedActivity.startTime,
          end: plannedActivity.endTime,
        })
      );
    }

    return formatToLocaleEventDate(plannedActivity.performAt, false);
  })();

  const getTimeDifference = () => {
    const start = getPlannedActivityDueDate(plannedActivity);
    const end = new Date();

    end.setSeconds(0);
    end.setMilliseconds(0);

    return getReadableTimeDifferenceInLocale(start, end);
  };

  return (
    <Alert
      title={t('plannedActivities:alerts.overdue.title')}
      severity="warning"
    >
      {t('plannedActivities:alerts.overdue.body', {
        date: dateStr,
        diff: getTimeDifference(),
      })}
    </Alert>
  );
};
